export const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export const headersFiles = {
  "Accept":"*/*",
}